/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportDocumentsModelDto } from '../../models/export-documents-model-dto';

export interface ExportDocumentsGetExportCcda$Params {
  patientId?: string | null;
  PracticeId?: string | null;
  comments?: string | null;
}

export function exportDocumentsGetExportCcda(http: HttpClient, rootUrl: string, params?: ExportDocumentsGetExportCcda$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportDocumentsModelDto>> {
  const rb = new RequestBuilder(rootUrl, exportDocumentsGetExportCcda.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('comments', params.comments, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportDocumentsModelDto>;
    })
  );
}

exportDocumentsGetExportCcda.PATH = '/exportdocument/getExportCCDA';
